function postProcessOrgField(organisation, units, metadata) {
    return {
        value: {
            organisation,
            department: units,
        },
        ...metadata
    };
}

export function postProcessOrgFields(cards) {
    return cards.map(card => {
        if (!(card.org && card.org.value)) {
            return card;
        }
        let [organisation, ...units] = card.org.value;

        // creates a new card with a modified 'org' field
        return {
            ...card,
            org: postProcessOrgField(organisation, units.join(", "))
        };
    });
}